export const getMetafieldMap = (product) => {
  if (!product?.metafields?.length) return {};
  const ogMetafields = product.metafields;
  function getMetafield({namespace, key}) {
    return ogMetafields.find(metafield => metafield.namespace === namespace && metafield.key === key);
  }
  function getMetafieldsByNamespace(namespace) {
    const metafieldsList = ogMetafields.filter(metafield => metafield.namespace === namespace);
    return metafieldsList.reduce((acc, { key, value }) => {
      return { ...acc, [key]: value };
    }, {})
  }

  return {...product.metafields.reduce((acc, { key, value }) => {
      return { ...acc, [key]: value };
    }, {}),
    getMetafield,
    getMetafieldsByNamespace,
    ogMetafields,
  }
};
